import { render, staticRenderFns } from "./new-item.vue?vue&type=template&id=252d756a&"
import script from "./new-item.vue?vue&type=script&lang=ts&"
export * from "./new-item.vue?vue&type=script&lang=ts&"
import style0 from "./new-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports